/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_X15_Gone_BodyInputs */

const en_invite_x15_gone_body = /** @type {(inputs: Invite_X15_Gone_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It has expired, was withdrawn or was already used. Ask the person who invited you to send a new one.`)
};

/** @type {(inputs: Invite_X15_Gone_BodyInputs) => LocalizedString} */
const ar_invite_x15_gone_body = en_invite_x15_gone_body;

/** @type {(inputs: Invite_X15_Gone_BodyInputs) => LocalizedString} */
const he_invite_x15_gone_body = en_invite_x15_gone_body;

/** @type {(inputs: Invite_X15_Gone_BodyInputs) => LocalizedString} */
const ur_invite_x15_gone_body = en_invite_x15_gone_body;

/** @type {(inputs: Invite_X15_Gone_BodyInputs) => LocalizedString} */
const es_invite_x15_gone_body = en_invite_x15_gone_body;

/** @type {(inputs: Invite_X15_Gone_BodyInputs) => LocalizedString} */
const fr_invite_x15_gone_body = en_invite_x15_gone_body;

/** @type {(inputs: Invite_X15_Gone_BodyInputs) => LocalizedString} */
const de_invite_x15_gone_body = en_invite_x15_gone_body;

/** @type {(inputs: Invite_X15_Gone_BodyInputs) => LocalizedString} */
const pt_invite_x15_gone_body = en_invite_x15_gone_body;

/** @type {(inputs: Invite_X15_Gone_BodyInputs) => LocalizedString} */
const hi_invite_x15_gone_body = en_invite_x15_gone_body;

/** @type {(inputs: Invite_X15_Gone_BodyInputs) => LocalizedString} */
const bn_invite_x15_gone_body = en_invite_x15_gone_body;

/**
* | output |
* | --- |
* | "It has expired, was withdrawn or was already used. Ask the person who invited you to send a new one." |
*
* @param {Invite_X15_Gone_BodyInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_x15_gone_body = /** @type {((inputs?: Invite_X15_Gone_BodyInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_Gone_BodyInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_x15_gone_body(inputs)
	if (locale === "he") return he_invite_x15_gone_body(inputs)
	if (locale === "ur") return ur_invite_x15_gone_body(inputs)
	if (locale === "es") return es_invite_x15_gone_body(inputs)
	if (locale === "fr") return fr_invite_x15_gone_body(inputs)
	if (locale === "de") return de_invite_x15_gone_body(inputs)
	if (locale === "pt") return pt_invite_x15_gone_body(inputs)
	if (locale === "hi") return hi_invite_x15_gone_body(inputs)
	if (locale === "bn") return bn_invite_x15_gone_body(inputs)
	return /** @type {LocalizedString} */ ("It has expired, was withdrawn or was already used. Ask the person who invited you to send a new one.")
});